import { Component, Element, Event, EventEmitter, h, Host, Prop, State } from "@stencil/core";

@Component({
    tag: "ux-filterable-list",
    shadow: true,
    styleUrl: "filterable-list.scss"
})
export class FilterableList {
    @Element() domNode!: HTMLUxFilterableListElement;

    /**
     * Emitted when the filter value changes
     */
    @Event()
    uxFilterChange!: EventEmitter;

    /**
     *  The filterable list items
     */
    @Prop() readonly filterable: boolean = false;
    /**
     * The filter string to be applied to the list
     * @default empty
     */
    @Prop() readonly filter?: string;

    /**
     * The placeholder text to be displayed in the search input
     */
    @Prop() readonly searchPlaceholder?: string = "Search";

    /**
     *  The message to be displayed when no items are found
     */
    @Prop() readonly noContentMessage?: string = "No items found";

    @State() numOfItems: number;

    private filterValue = "";

    /** returns true when item should be shown according to the filter */
    private isInFilter(itemName: string): boolean {
        return this.filterValue.length === 0 || itemName.toLowerCase().includes(this.filterValue);
    }

    /**
     * Handles the filter change event.
     * @param event - The keyboard event.
     */
    private onFilterChange(event: CustomEvent) {
        const inputElement = event.target as HTMLInputElement;
        this.filterValue = inputElement.value.toLowerCase();
        // @ts-expect-error Check for typing
        const slottedElements = this.domNode.shadowRoot.querySelector("slot").assignedElements();
        for (const element of slottedElements) {
            const label = element.getAttribute("label") || element.getAttribute("value") || element.getAttribute("name");
            const slottedElement = element as HTMLElement;
            // @ts-expect-error Check for typing
            slottedElement.hidden = !this.isInFilter(label);
        }
        // @ts-expect-error Check for typing
        this.numOfItems = slottedElements.filter((element: HTMLElement) => !element.hidden).length;
    }

    public render() {
        const filterInput = this.filterable && (
            <div class="ux-list__filter">
                <ux-input
                    id="searchInput"
                    type="text"
                    placeholder={this.searchPlaceholder}
                    onUxInput={(e) => this.onFilterChange(e)}
                ></ux-input>
            </div>
        );

        return (
            <Host role="list">
                {filterInput}
                <slot />
                {this.numOfItems === 0 && <div id="noContent">{this.noContentMessage}</div>}
            </Host>
        );
    }
}
